var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay"},[_c('div',{staticClass:"loading-spinner"},[_c('div',{staticClass:"spin-icon",style:(_vm.loadingColor)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }